import { useEffect, useRef, useState } from "react";
import { GenericComponent } from "../../components/GenericComponent";
import { Grupo } from "../../models/administracion/Grupo";
import { useForm } from "react-hook-form";
import { GrupoEmpresaService } from "../../service/GrupoEmpresaService";
import { InputComponent } from "../../components/InputComponent";
import { confirmDialog } from "primereact/confirmdialog";
import { Toast } from "primereact/toast";
import { Card } from "primereact/card";
import { Toolbar } from "primereact/toolbar";
import { Dialog } from "primereact/dialog";
import { GrupoEmpresaDetalle } from "./GrupoEmpresaDetalle";

export const GrupoEmpresa = () => {

    const generic = new GenericComponent();
    const omodel = new Grupo();
    const [permss, setPermss] = useState(null);
    const defaultValues = generic.default(omodel.model, null);
    const { control, formState: { errors }, handleSubmit, reset, setError, getValues } = useForm({ defaultValues });
    const toast = useRef(null);
    const [grupos, setGrupos] = useState(null);
    const [grupo, setGrupo] = useState(null);
    const grupoService = new GrupoEmpresaService();
    const [dialogGrupo, setDialogGrupo] = useState(false);
    const [dialogDetalle, setDialogDetalle] = useState(false);
    const [fileSize, setFileSize] = useState(0);
    const [load, setLoad] = useState(false);
    const { table, setLoading, setTotalRecords, lazyParams, inDrop, inText, inFile } = InputComponent({ registers: grupos, omodel, generic, errors, control, permss, id: getValues('id') });

    useEffect(() => {
        loadLazyData();
    }, [lazyParams]);

    const loadLazyData = () => {
        setLoading(true);

        const _lazyParams = lazyParams;
        delete _lazyParams.rtipo;
        if (permss == null) {
            _lazyParams.rtipo = true;
        }
        grupoService.getGrupoEmpresa({ lazyEvent: JSON.stringify(_lazyParams) }).then(res => {
            setTotalRecords(res.data.total);
            setGrupos(res.data.registros);
            setLoading(false);
            if (res.data.perss !== undefined) {
                setPermss(res.data.perss);
            }
        });
    }

    const openNew = () => {
        setDialogGrupo(true);
        reset(defaultValues);
    }

    const buildFormData = (data) => {
        const formData = new FormData();
        Object.keys(data).forEach((key) => {
            const value = data[key];
            if (value === null || value === undefined) return;
            if(key === 'logo' && value instanceof File) formData.append(key, value); // Append the File object directly
            else formData.append(key, typeof value === 'object' ? JSON.stringify(value) : value);
        });
        return formData;
    }

    const onSubmit = (data) => {
        setLoad(true);
        const enviarData = data.logo != null ? buildFormData(data) : data;
        const request = getValues('id') == null ? grupoService.newGrupoEmpresa(enviarData) : grupoService.editarGrupoEmpresa(enviarData);
        request.then(res => {
            generic.funcSuccess(res, toast);
            setDialogGrupo(false);
            loadLazyData();
        }).catch(error => {
            generic.funcError(error, toast, setError);
        }).finally(() => setLoad(false));
    }

    const editEmpresa = (grupo) => {
        grupoService.consultarGrupoEmpresa(grupo.id).then(res => {
            let _grupo = res.data;
            const lista = { estado: generic.estados, corporacion: generic.sino };

            Object.keys(lista).forEach(function (key) {
                if (_grupo[key] != null) {
                    lista[key].forEach(element => {
                        if (element.cat_id === _grupo[key]) {
                            _grupo[key] = element;
                        }
                    });
                }
            });
            reset(generic.renewValues(_grupo, omodel.model));
            setDialogGrupo(true);
        });
    };

    const confirmDelete = (data) => {
        confirmDialog({
            message: '¿Está seguro de eliminar el grupo?',
            header: 'Confirmación',
            icon: 'pi pi-exclamation-triangle',
            accept: () => eliminarGrupo(data)
        });
    }

    const eliminarGrupo = (data) => {
        grupoService.eliminarGrupoEmpresa(data.id).then(res => {
            loadLazyData();
            generic.funcSuccess(res, toast);
        }).catch(error => {
            generic.funcDeleteError(error, toast);
        });
    }

    const anadirEmpresas = (data) => {
        setGrupo(data);
        setDialogDetalle(true);
    }

    const onError = (errors, e) => {
        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Por favor complete los campos requeridos.', life: 3000 });
    }

    return (
        <>
            <Toast ref={toast} />
            <Card style={{ maxWidth: '100%', margin: 'auto' }}>
                <Toolbar className="mb-4" start={generic.leftToolbarTemplate(openNew, 'Nuevo grupo', permss)}
                    end={generic.rightToolbarTemplate(grupos, omodel, 'Listado_grupo', 'LISTADO GRUPO')}></Toolbar>
                {table({ action3: generic.actionEditDetailTemplate, methEdit: editEmpresa, perm: permss, methDelete: confirmDelete, details: anadirEmpresas, icono: 'pi pi-qrcode' })}
            </Card>

            <Dialog visible={dialogGrupo} header={getValues('id') == null ? "Nuevo Grupo" : "Editar grupo"} modal className="p-fluid modal-ssize" onHide={e => setDialogGrupo(false)}>
                <form onSubmit={handleSubmit(onSubmit, onError)}>
                    <div className="formgrid grid">
                        {inText('nombre_grupo', {}, 12)}
                        {inDrop('corporacion', generic.sino, { lab: omodel.optionLabel }, 6)}
                        {inDrop('estado', generic.estados, { lab: omodel.optionLabel }, 6)}
                        {inFile('logo', { fileSize, setFileSize, obl: false, ml: ' ml-2', }, 12)}
                    </div>

                    {generic.buttonsForms(setDialogGrupo, load)}
                </form>
            </Dialog>

            <Dialog visible={dialogDetalle} header="Empresas asignadas" modal className="p-fluid modal-ssize" onHide={e => setDialogDetalle(false)}
                style={{ maxWidth: '1000px' }}>
                {grupo?.corporacion === 'NO' && <GrupoEmpresaDetalle grupoId={grupo?.id} generic={generic} toast={toast} />}
                {grupo?.corporacion === 'SI' && <b>No se puede agregar empresas a un grupo corporativo por esta funcionalidad.</b>}
            </Dialog>
        </>
    )
}
